import type { Pixel } from '@entities/product/api/product.contract'
import { pixelIdFormatError } from '@shared/contracts/pixels'

export type PixelFieldErrors = Record<string, string>

function fieldPath(pixel: Pixel, field: string) {
  return `pixels.${pixel.id}.${field}`
}

export function validateProductPixels(pixels: readonly Pixel[]): PixelFieldErrors {
  const errors: PixelFieldErrors = {}

  for (const pixel of pixels) {
    if (pixel.provider === 'facebook' || pixel.provider === 'tiktok') {
      if (!pixel.pixelId.trim()) {
        errors[fieldPath(pixel, 'pixelId')] = 'Informe o Pixel ID.'
        continue
      }
      const formatError = pixelIdFormatError(pixel)
      if (formatError) errors[fieldPath(pixel, 'pixelId')] = formatError
      continue
    }

    if (pixel.provider === 'google_ads') {
      if (!pixel.pixelId.trim()) {
        errors[fieldPath(pixel, 'pixelId')] = 'Informe o Conversion ID.'
      } else {
        const formatError = pixelIdFormatError(pixel)
        if (formatError) errors[fieldPath(pixel, 'pixelId')] = formatError
      }
      if (!pixel.conversionLabel.trim()) {
        errors[fieldPath(pixel, 'conversionLabel')] = 'Informe o rótulo de conversão.'
      }
      continue
    }

    if (!pixel.accessToken.trim()) {
      errors[fieldPath(pixel, 'accessToken')] = 'Cole a credencial de API da UTMify.'
    }
  }

  return errors
}
